import { render, staticRenderFns } from "./residentDetail.vue?vue&type=template&id=3ea6641b&scoped=true&"
import script from "./residentDetail.vue?vue&type=script&lang=js&"
export * from "./residentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea6641b",
  null
  
)

export default component.exports